export default __webpack_public_path__ + "static/media/avatar_8.bf92eb83.svg";